
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'



export default {
directives: {
TransferDom
},
components: {
Group,
XButton,
Confirm,
XDialog,

},
name: 'UploadCard',
data () {
return {
currentPhoto: '',
imgLen: 0,
card: {
cardFront: null,
cardFrontBase64: '',
cardBack: null,
cardBackBase64: '',
cardHand: null,
cardHandBase64: ''
},
name: this.$route.query.name,
idNum: this.$route.query.idNum,
phoneNum: this.$route.query.phoneNum,
UserInfo: {
ide:''
},
show: false,

ide: ''
}
},
created(){
const openid = window.sessionStorage.getItem("openId")
},
computed: {
isPhoto: function () {
return this.card['cardFront'] != null && this.card['cardBack'] != null && this.card['cardHand'] != null
}
},
methods: {

beforeRouteLeave(to, from, next){
to.meta.keepAlive = true
next()
},
getImages(name, file) {
if (file != null) {
return this.getObjectURL(file)
} else if (name != undefined && name != null) {
return require(`@/assets/images/${name}.png`)
} else {
return require(`@/assets/images/default.png`)
}
},
getObjectURL(file) {
var url = null;
if (window.createObjectURL != undefined) { // basic
url = window.createObjectURL(file);
} else if (window.URL != undefined) { // mozilla(firefox)
url = window.URL.createObjectURL(file);
} else if (window.webkitURL != undefined) { // webkit or chrome
url = window.webkitURL.createObjectURL(file);
}
return url;
},
takePhoto(event){










var ua = navigator.userAgent;
var wechatInfo = ua.match(/MicroMessenger\/([\d\.]+)/i);
var filter = [{
title: "Image files",
extensions: "jpg,png,jpeg"
}];

if (/android/.test(ua.toLowerCase()) && wechatInfo && parseFloat(wechatInfo[1]) > 6.3) {
filter = [];
}
let imageFile = event.target.files[0];
this.card[event.target.name] = imageFile;
let that = this;
var img = new Image();
img.src = this.getObjectURL(imageFile);

img.onload = function () {
var originWidth = this.width; 
var originHeight = this.height;
var maxWidth = 400;
var quality = 0.9; 
var canvas = document.createElement('canvas');
var drawer = canvas.getContext("2d");
canvas.width = maxWidth;
canvas.height = originHeight / originWidth * maxWidth;
drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
var base64 = canvas.toDataURL("image/jpeg", quality); 
that.card[event.target.name + 'Base64'] = base64;
};

},



















submitUserInfo(){
const url = '/wechat/register.do';
this.$axios({
method: 'post',
url: url,
data: {
openId: window.sessionStorage.getItem("openId"),
userName: this.$route.query.userName,


movePhone: this.$route.query.movePhone,

cardPhotoBack: this.card['cardBackBase64'],
cardPhotoBackName: this.card['cardBack'].name,
cardPhotoFace: this.card['cardFrontBase64'],
cardPhotoFaceName: this.card['cardFront'].name,
cardPhotoPortrait: this.card['cardHandBase64'],
cardPhotoPortraitName: this.card['cardHand'].name,
}
}).then((response) => {
if (response.data.code === 200) {//pls 200

this.UserInfo = response.data.result || {};
this.ide = this.UserInfo.ide || this.UserInfo.IDE;

if (this.UserInfo.certificationUrl) {
window.location.href = this.UserInfo.certificationUrl;
} else {
this.show = true;
}
} else {


}
})
},

onConfirm () {

let productId = window.sessionStorage.getItem("productDetail_productId")
let productCode = window.sessionStorage.getItem("productDetail_productCode")
let organId = window.sessionStorage.getItem("productDetail_organId")||''
if (productId != undefined && productCode != undefined && productId != '' && productCode != '' && productId != null && productCode != null) {
this.$router.push({
path: '/productDetail',
query: {
productId: productId,
productCode: productCode,
organId:organId
}
});
} else {
this.$router.push({
path: '/personInfo',
query: {
userName: this.$route.query.userName,
ide: this.UserInfo.ide,
movePhone: this.$route.query.movePhone,
}
})
}

},

}
}



// WEBPACK FOOTER //
// ./src/pages/UploadIDCard.vue